import type { PropertySchemeQuoteResult } from '../SchemeQuoteResult'
import { JsonObject, JsonProperty } from 'json2typescript'
import PaymentTypeEnumConverter from '@/converters/PaymentTypeEnumConverter'
import { PaymentTypeEnum } from '@/services/enums/DLDCommonValuesEnum'
import QuoteDetails from '../QuoteDetails'
import RiskProposer from '../RiskProposer'
import Property from './Property'

@JsonObject('PropertyQuoteDetails')
export default class PropertyQuoteDetails extends QuoteDetails<PropertySchemeQuoteResult> {
  @JsonProperty('riskProposer', RiskProposer)
  propertyProposer: RiskProposer = new RiskProposer()

  @JsonProperty('properties', [Property])
  properties: Property[] = []
}

@JsonObject('PropertyRenewalQuoteDetails')
export class PropertyRenewalQuoteDetails extends PropertyQuoteDetails {
  @JsonProperty('initialPaymentMethod', PaymentTypeEnumConverter)
  initialPaymentMethod: PaymentTypeEnum = PaymentTypeEnum.CardPayment

  @JsonProperty('previousPolicyScheme', String)
  previousPolicyScheme = ''
}

@JsonObject('PropertyMTAQuoteDetails')
export class PropertyMTAQuoteDetails extends PropertyQuoteDetails {
  @JsonProperty('initialPaymentMethod', PaymentTypeEnumConverter)
  initialPaymentMethod: PaymentTypeEnum = PaymentTypeEnum.CardPayment

  @JsonProperty('hasUpgradableVAP', Boolean)
  hasUpgradableVAP = true

  @JsonProperty('hasClaims', Boolean)
  hasClaims = false

  @JsonProperty('message', String)
  message = ''
}
